<template>
  <div v-if="condition(scan, roles)">
    <slot v-bind:scan="scan" v-bind:roles="roles"></slot>
  </div>
</template>

<script>
import { Mixins } from "@bvm/core";

export default {
  name: "scan-aware-renderer",
  mixins: [Mixins.Roles],
  props: {
    condition: {
      type: Function,
      required: false,
      default: () => true
    }
  },
  computed: {
    scan() {
      return this.$store.state.scan;
    }
  }
};
</script>
